<template lang="pug">
  b-table(striped hover ,:fields="activityFields" ,:items="lastActions" ,@row-clicked="showComplaintDetails")
    template(slot="message" scope="data")
      span(:class="`role-${roleClass(data.item.role, data.item.action)}`") {{ roles[data.item.role].name }} / {{ data.item.name }}
      |  {{ data.item.action | formatAction }}
      router-link(:to="{ name: ecommerce ? 'show_complaint_ecommerce' : 'show_complaint', params: { complaint_id: data.item.complaint } }" ) {{ ` #${data.item.number}` }}
      span(v-if="data.item.message") . {{ data.item.message | stripHTML }}.
      span(v-if="data.item.created_at")  - {{ data.item.created_at | formatCommentDate }}
</template>

<script>
import kexaApi from '@/services/apiService';
import constants from '@/constants/Status.constants';

export default {
  name: 'last-activity',
  data() {
    return {
      activityFields: {
        message: {
          label: 'Última actividad',
        },
      },
      lastActions: [],
      intervalId: null,
      roles: constants.ROLES,
    };
  },
  created() {
    this.fetchActivities();
  },
  methods: {
    fetchActivities() {
      kexaApi.activities(this.complaint, this.ecommerce)
        .then((data) => {
          this.lastActions = data.body;
        });
    },
    showComplaintDetails(item) {
      this.$router.push(`/complaints/${item.complaint}`);
    },
    pollActivities() {
      this.intervalId = setInterval(() => {
        this.fetchActivities();
      }, 120000);
    },
    roleClass(roleId, action) {
      if (action.includes('error')) { return 'error'; }

      if (roleId === 2) {
        return 'crm';
      } else if (roleId === 3) {
        return 'err';
      } else if (roleId === 4) {
        return 'edb';
      } else if (roleId === 5) {
        return 'fin';
      }
      return 'empty';
    },
  },
  props: {
    complaint: {
      type: [String, Number],
      required: false,
    },
    ecommerce: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.pollActivities();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/LastActivity.vue